module.exports = function (Restangular, $cacheFactory) {
    function DynamicContentService() {
        this._api = Restangular.one('DynamicContent');
        this._logMetricsApi = this._api.all('LogMetrics');
        this.cache = $cacheFactory('dynamic-content-cache');

        //This is used for versioning of the schedule. i.e when the user logs on
        this.scheduleVersion = 0;

        this.templatesPromise = null;
    }

    DynamicContentService.prototype.getServerItems = function (params) {
        return this._api.get(params).then(function (items) {
            return items.rawResponse;
        });
    };

    DynamicContentService.prototype.getContent = function (params) {
        return this._api.one('Content').get(params);
    };

    /**
     * Stores the Dynamic content in an array of objects. Contains the HTML and the Schedule key
     * @param content
     */
    DynamicContentService.prototype.cacheContent = function (content) {
        this.cache.put(content.id, content.html);
    };

    /**
     * Gets the DC using the schedule key (URL + either top or bottom content)
     * @param id
     */
    DynamicContentService.prototype.getCachedContent = function (id) {

        if (this.cache.info().size > 0) {
            return this.cache.get(id);
        }

        return undefined;
    };

    /**
     * Invalidates the cache
     */
    DynamicContentService.prototype.invalidateCache = function () {
        this.cache.removeAll();
    };

    DynamicContentService.prototype.getManageTemplates = function () {
        if (this.templatesPromise === null) {
            this.templatesPromise = this._api.one('ManagementTemplates').get();
        }
        return this.templatesPromise.then((e) => {
            if (e) {
                e = e.replace(`<script type="text/javascript" src="/DynamicContent2/javascript/jquery-ui-1.10.4.min.js"></script>`, ``);
                e = e.replace(`<script type="text/javascript" src="/DynamicContent2/javascript/lodash.3.10.1.js"></script>`, ``);
                e = e.replace(`/DynamicContent2/javascript/DynamicContent.js`, `/DynamicContent2/javascript/DynamicContent.js?v=lodashupdate1`);
                e = e.replace(`/DynamicContent2/javascript/ItemTypes/productGroup.js`, `/DynamicContent2/javascript/ItemTypes/productGroup.js?v=lodashupdate`);
                e = e.replace(`/DynamicContent2/javascript/ItemTypes/productGroupCarousel.js`, `/DynamicContent2/javascript/ItemTypes/productGroupCarousel.js?v=lodashupdate`);

                
            }
            return Promise.resolve(e);
        });
    };

    DynamicContentService.prototype.isManagementEnabled = function () {
        // If dc is in window, the dynamic content management scripts are enabled,
        // meaning the user is able to manage dynamic content.
        return 'dc' in window;
    };


    DynamicContentService.prototype.postMetricsClick = function (itemId) {
        return this._logMetricsApi.post({ itemId });
    };

    return new DynamicContentService();
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/dynamic-content-service.js
 **/